import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SignupPage from './pages/SignupPage';
import AccountPage from './pages/AccountPage';
import DetailsPage from './pages/DetailsPage';
import DepositPage from './pages/DepositPage';
import WithdrawPage from './pages/WithdrawPage';
import TransferPage from './pages/TransferPage';
import OpenPage from './pages/OpenPage';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/signup' element={<SignupPage />} />
        <Route path='/account' element={<AccountPage />} />
        <Route path='/details' element={<DetailsPage />} />
        <Route path='/deposit' element={<DepositPage />} />
        <Route path='/withdraw' element={<WithdrawPage />} />
        <Route path='/transfer' element={<TransferPage />} />
        <Route path='/open' element={<OpenPage />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
